import ContattiPage from "./ContattiPage";

export default function AssistenzaPage() {
  return (
    <div data-testid="assistenza-page">
      <div className="mx-auto max-w-2xl px-4 pt-12 sm:px-6">
        <p className="rounded-lg border border-bordeaux/30 bg-bordeaux-ultralight px-4 py-3 text-sm text-bordeaux-dark">
          Hai bisogno di aiuto? Scrivici con il modulo qui sotto oppure usa l'assistente virtuale in basso a destra per le domande più frequenti.
        </p>
      </div>
      <div className="-mt-8">
        <ContattiPage />
      </div>
    </div>
  );
}
